<template>
    <div>
        <div class="embed-responsive embed-responsive-16by9" v-if="type.includes('video/')">
            <video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered embed-responsive-item" preload="none" width="100%" height="100%" ></video>
        </div>
        <div class="audio-player" v-if="type.includes('audio/')">
            <div class="text-center w-100" style="padding: 20% 0;">
                <svg class="icon icon-music text-center"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/icons.svg#icon-music"></use></svg>
            </div>
            <audio ref="audioPlayer" class="video-js vjs-default-skin vjs-audio" controls autoplay  data-setup='{ "aspectRatio":"1:0" }'></audio>
        </div>

        <div class="modal fade" id="subtitlesListModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h6 class="modal-title">Add Subtitles</h6>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                
                    <div class="col-md-12 p-2 text-center" v-if="loading_subtitles">
                        <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="col-md-12 p-2 text-center" v-else>
                        <div class="row">
                        
                            <div class="col-md-12" v-if="subtitles.length > 0">
                                <div class="table-responsive">
                                    <table class="table w-100">
                                        <thead>
                                            <tr>
                                                <th class="text-left">Filename</th>
                                                <th>Language</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(subtitle, index) in subtitles" v-if="subtitle.name.split('.').pop() == 'srt'">
                                                <td class="text text-left"><span>{{ subtitle.name }}</span></td>
                                                <td>{{ subtitle.language }}</td>
                                                <td>
                                                    <button id="apply_btn" class="btn btn-sm btn-primary" @click="applySubtitle($event,hash,subtitle)">Apply</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-12" v-else>
                                <div class="alert alert-danger alert-block px-0  text-center">No subtitles found.</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-12 mt-2">
                      <div class="strike">
                          <span> or </span>
                      </div>
                      <br>
                      <p class="text-center"><button class="btn btn-primary btn-block" @click="searchSubtitle">Search for attached Subtitles</button></p>
                      
                    </div> -->
                    <div class="col-md-12 mt-2">
                      <div class="strike">
                          <span> or </span>
                      </div>
                      <br>
                      <form method="POST" action="" class="text-center" enctype="multipart/form-data" id="subtitleForm">
                       <input class="d-none" id="subtitleInput" @change="uploadSubtitle" type="file" name="subtitle" accept=".srt, .vtt">
                      </form>
                      <p class="text-center"><button class="btn btn-primary btn-block" @click="clickUpload" id="btnUpload">Upload own Subtitles</button></p>
                    </div>
                 
                </div>
              </div>
            </div>
        </div>
        <div class="modal fade" id="searchSubtitlesModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h6 class="modal-title">Add Subtitles</h6>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                
                    
                 
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import videojs from 'video.js';
require('videojs-hotkeys');
require('@silvermine/videojs-airplay')(videojs);
require('@silvermine/videojs-chromecast')(videojs, { preloadWebComponents: true });
require('videojs-hls-quality-selector');

export default {
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        },
        type: {
            type: String,
            default() {
                return null;
            }
        },
        hash: {
            type: String,
            default() {
                return null;
            }
        },
        id: {
            type: String,
            default() {
                return null;
            }
        }
    },
    data() {

        return {
            player: null,
            loading_subtitles: true, 
            subtitles: {},
        }
    },
    mounted() {
        var self = this;
        if(this.type.includes('video/')){
            
           
          this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {  
              this.hotkeys({
                  volumeStep: 0.1,
                  seekStep: 5,
                  alwaysCaptureHotkeys: true
              });

              this.chromecast();
              this.airPlay();
              this.hlsQualitySelector({
                displayCurrentQuality: false,
              });
          });

          var qualities = this.player.qualityLevels();
          var qualitySelector = this.player.hlsQualitySelector({displayCurrentQuality:true});
          qualities.on('addqualitylevel', () => {
            var q = qualities[qualities.length - 1]
            if (q.height === 1080) {
              console.log(`Requested quality found; changing stream to: "${q.label}"`)
              qualitySelector.setQuality(1080);
            } else if (q.height === 720) {
              console.log(`Requested quality found; changing stream to: "${q.label}"`)
              qualitySelector.setQuality(720);
            } 
          })

          let player = this.player;
          class CaptionButton extends videojs.getComponent("Button") {
            constructor(player, options) {
              super(player, options);
              this.addClass( 'fas' );
              this.addClass( 'fa-search' );
              this.controlText('Find and load Subtitles');
            }

            handleClick() {
              $("#subtitlesListModal").modal('show');
              $('#btnUpload').html('Upload own Subtitle');
              $('button[id^="apply_btn"]').html('Apply');
              $('button[id^="apply_btn"]').prop('disabled', false);
              
              axios.post('/api/item/subtitles',{item_id : self.id}).then( response=> {
                self.loading_subtitles = false;
                self.subtitles = response.data.subtitles;
                console.log(self.subtitles);
              }).catch(error=>{
                flash(JSON.parse(error.request.response).message, 'error');
              });
            }
          }

          videojs.registerComponent("CaptionButton", CaptionButton);

          player.ready(() => {
            const buttonInstance = player.addChild("CaptionButton", {});
            player.controlBar.addChild(buttonInstance, {}, player.controlBar.children().length - 1);
          });

        } else {

            this.player = videojs(this.$refs.audioPlayer, this.options, function onPlayerReady() {  
                this.hotkeys({
                    volumeStep: 0.1,
                    seekStep: 5,
                    alwaysCaptureHotkeys: true
                });
                //console.log('onPlayerReady', this);
            });
        }

    },
    methods: {
        searchSubtitle(){
          $('#subtitlesListModal').modal('toggle');
          $("#searchSubtitlesModal").modal('show');

          // axios.post('/api/folder/list',{folder_id : this.folder_id}).then( response=> {
          //     this.items = response.data.files.content;
          //     this.current_folder = { name: response.data.files.name, parent_id : response.data.files.parent_id};
          // }).catch(error=>{
          //     flash(JSON.parse(error.request.response).message, 'error');
          // });
        },
        uploadSubtitle(){

            $('button[id="btnUpload"]').prop('disabled', true);
            $('button[id="btnUpload"]').html('<i class="fas fa-spinner fa-pulse"></i>');

            let data = new FormData();
            data.append('subtitle', document.getElementById('subtitleInput').files[0]);

            axios.post('/api/item/apply/subtitles',data).then( response=> {
                
                $('button[id="btnUpload"]').prop('disabled', false);
                $('button[id="btnUpload"]').html('Upload own Subtitle');

                if (response.data.status == 'success') {

                    // Get all text tracks for the current player.
                    var tracks = this.player.textTracks();

                    for (i = 0; i < tracks.length; i++) {
                      this.player.removeRemoteTextTrack(tracks[i]);
                    }

                    this.player.addRemoteTextTrack({ src: response.data.content, kind: 'captions', srclang: 'en', label: 'Custom'}, false);

                    for (var i = 0; i < tracks.length; i++) {
                      tracks[i].mode = 'showing';
                    }

                    //$('.vjs-subs-caps-button').addClass("vjs-hidden");

                    $('.vjs-chromecast-button').addClass("vjs-hidden");

                    setTimeout(function(){
                       $('#subtitlesListModal').modal('toggle');
                    }, 500);

                } 

            }).catch(error=>{
              console.log(error);
            });
    
        },
        clickUpload(){
            $("#subtitleInput").trigger("click");
        },
        applySubtitle(e,hash,subtitle){


            $('button[id^="apply_btn"]').prop('disabled', true);
            $('button[id^="apply_btn"]').html('Apply');

            e.target.disabled = true;
            e.target.innerHTML = '<i class="fas fa-spinner fa-pulse"></i>';

            axios.post('/api/item/apply/subtitles',{action: 'opensubtitles', hash : hash, filename : subtitle.name, dl_link: subtitle.dl_link}).then( response=> {
                
                $('button[id^="apply_btn"]').prop('disabled', false);

                e.target.disabled = false;   

                if (response.data.status == 'success') {
                    e.target.innerHTML = 'Applied';

                    // Get all text tracks for the current player.
                    var tracks = this.player.textTracks();

                    for (i = 0; i < tracks.length; i++) {
                      this.player.removeRemoteTextTrack(tracks[i]);
                    }

                    var vttText = this.srt2webvtt(response.data.content);
                    var vttBlob = new Blob([vttText], {type : 'text/vtt'});
                    var blobURL = URL.createObjectURL(vttBlob);
                    console.log(vttText);

                    this.player.addRemoteTextTrack({
                      src: blobURL,
                      kind: 'captions',
                      srclang: subtitle.iso_code,
                      label: subtitle.language
                    }, false);

                    for (var i = 0; i < tracks.length; i++) {
                      tracks[i].mode = 'showing';
                    }

                    //$('.vjs-subs-caps-button').addClass("vjs-hidden");

                    $('.vjs-chromecast-button').addClass("vjs-hidden");

                    setTimeout(function(){
                       $('#subtitlesListModal').modal('toggle');
                    }, 500);

                } else {
                   
                    e.target.disabled = false;
                    e.target.innerHTML = 'Error';
                }

            }).catch(error=>{
              console.log(error);
            });
        },

        srt2webvtt(data) {
          // remove dos newlines
          var srt = data.replace(/\r+/g, '');
          // trim white space start and end
          srt = srt.replace(/^\s+|\s+$/g, '');

          // get cues
          var cuelist = srt.split('\n\n');
          var result = "";

          if (cuelist.length > 0) {
            result += "WEBVTT\n\n";
            for (var i = 0; i < cuelist.length; i=i+1) {
              result += this.convertSrtCue(cuelist[i]);
            }
          }

          return result;
        },
        convertSrtCue(caption) {
          // remove all html tags for security reasons
          //srt = srt.replace(/<[a-zA-Z\/][^>]*>/g, '');

          var cue = "";
          var s = caption.split(/\n/);

          // concatenate muilt-line string separated in array into one
          while (s.length > 3) {
              for (var i = 3; i < s.length; i++) {
                  s[2] += "\n" + s[i]
              }
              s.splice(3, s.length - 3);
          }

          var line = 0;

          // detect identifier
          if (!s[0].match(/\d+:\d+:\d+/) && s[1].match(/\d+:\d+:\d+/)) {
            cue += s[0].match(/\w+/) + "\n";
            line += 1;
          }

          // get time strings
          if (s[line].match(/\d+:\d+:\d+/)) {
            // convert time string
            var m = s[1].match(/(\d+):(\d+):(\d+)(?:,(\d+))?\s*--?>\s*(\d+):(\d+):(\d+)(?:,(\d+))?/);
            if (m) {
              cue += m[1]+":"+m[2]+":"+m[3]+"."+m[4]+" --> "
                    +m[5]+":"+m[6]+":"+m[7]+"."+m[8]+"\n";
              line += 1;
            } else {
              // Unrecognized timestring
              return "";
            }
          } else {
            // file format error or comment lines
            return "";
          }

          // get cue text
          if (s[line]) {
            cue += s[line] + "\n\n";
          }

          return cue;
        }
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    }
}
</script>